import { Controller } from "@hotwired/stimulus";

import ApexCharts from "apexcharts";

export default class extends Controller {
  static values = {
    data: Array,
    categories: Array,
  };

  connect() {
    this.setChartColors();
  }

  setChartColors() {
    const colorScheme = ["#00c950", "#f1a03b"];

    const options = {
      series: this.dataValue,
      colors: colorScheme,
      labels: this.categoriesValue,
      chart: {
        type: "donut",
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            labels: {
              show: true,
              name: {
                show: false,
              },
              value: {
                show: true,
                fontSize: 13,
                offsetY: 5,
                style: {
                  colors: this.isDarkMode ? "#ffffff" : "#333",
                },
              },
              total: {
                show: true,
              },
            },
          },
        },
      },
      tooltip: {
        y: {
          formatter: this.valueFormatter,
        },
      },
      legend: {
        show: false,
      },
      states: {
        hover: {
          filter: {
            type: "none",
          },
        },
      },
      yaxis: {
        labels: {
          formatter: this.valueFormatter,
        },
      },
    };

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new ApexCharts(this.element, options);

    this.chart.render();
  }
}
